module.exports = __webpack_public_path__ + "static/img/xl2.8a9b00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl2.jpg
// module id = dUc9
// module chunks = 1